export const AtlassianCertificationLogoInverse = () => (
  <svg
    width="538"
    height="48"
    viewBox="0 0 538 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_815_1211)">
      <path
        d="M10.3 20.2001C9.8 19.6001 9 19.7001 8.6 20.4001L0.0999985 37.4001C-0.200001 38.0001 0.299999 38.8001 0.999999 38.8001H12.8C13.2 38.8001 13.5 38.6001 13.7 38.2001C16.3 33.0001 14.7 25.0001 10.3 20.2001Z"
        fill="url(#paint0_linear_815_1211)"
      />
      <path
        d="M16.5 4.8002C11.8 12.3002 12.1 20.6002 15.2 26.9002C18.3 33.2002 20.7 37.9002 20.9 38.3002C21.1 38.7002 21.4 38.9002 21.8 38.9002H33.6C34.4 38.9002 34.8 38.1002 34.5 37.4002C34.5 37.4002 18.6 5.6002 18.2 4.8002C17.9 4.0002 16.9 4.0002 16.5 4.8002Z"
        fill="white"
      />
      <path
        d="M155 18.4001C155 22.6001 156.9 25.9001 164.6 27.4001C169.1 28.4001 170.1 29.1001 170.1 30.6001C170.1 32.1001 169.1 33.0001 165.9 33.0001C162.2 33.0001 157.8 31.7001 154.9 30.0001V36.8001C157.2 37.9001 160.2 39.2001 165.9 39.2001C173.9 39.2001 177 35.6001 177 30.4001M177 30.4001C177 25.4001 174.4 23.1001 166.9 21.5001C162.8 20.6001 161.8 19.7001 161.8 18.4001C161.8 16.8001 163.3 16.1001 166 16.1001C169.3 16.1001 172.5 17.1001 175.6 18.5001V12.0001C173.4 10.9001 170.1 10.1001 166.2 10.1001C158.8 10.1001 155 13.3001 155 18.5001"
        fill="white"
      />
      <path
        d="M257.4 10.3003V38.8003H263.5V17.1003L266 22.9003L274.6 38.8003H282.2V10.3003H276.2V28.7003L273.9 23.4003L267 10.3003H257.4Z"
        fill="white"
      />
      <path d="M218.8 10.3003H212.2V38.8003H218.8V10.3003Z" fill="white" />
      <path
        d="M204.6 30.4001C204.6 25.4001 202 23.1001 194.5 21.5001C190.4 20.6001 189.4 19.7001 189.4 18.4001C189.4 16.8001 190.9 16.1001 193.6 16.1001C196.9 16.1001 200.1 17.1001 203.2 18.5001V12.0001C201 10.9001 197.7 10.1001 193.8 10.1001C186.4 10.1001 182.6 13.3001 182.6 18.5001C182.6 22.7001 184.5 26.0001 192.2 27.5001C196.7 28.5001 197.7 29.2001 197.7 30.7001C197.7 32.2001 196.7 33.1001 193.5 33.1001C189.8 33.1001 185.4 31.8001 182.5 30.1001V36.9001C184.8 38.0001 187.8 39.3001 193.5 39.3001C201.4 39.2001 204.6 35.7001 204.6 30.4001Z"
        fill="white"
      />
      <path
        d="M103.6 10.3003V38.8003H117.2L119.3 32.7003H110.2V10.3003H103.6Z"
        fill="white"
      />
      <path
        d="M76.7 10.3003V16.5003H84V38.8003H90.7V16.5003H98.6V10.3003H76.7Z"
        fill="white"
      />
      <path
        d="M67 10.3003H58.3L48.4 38.8003H56L57.4 34.0003C59.1 34.5003 60.9 34.8003 62.7 34.8003C64.5 34.8003 66.3 34.5003 68 34.0003L69.4 38.8003H77C76.9 38.8003 67 10.3003 67 10.3003ZM62.6 28.9003C61.3 28.9003 60.1 28.7003 59 28.4003L62.6 16.0003L66.2 28.4003C65.1 28.7003 63.9 28.9003 62.6 28.9003Z"
        fill="white"
      />
      <path
        d="M140.7 10.3003H132L122 38.8003H129.6L131 34.0003C132.7 34.5003 134.5 34.8003 136.3 34.8003C138.1 34.8003 139.9 34.5003 141.6 34.0003L143 38.8003H150.6L140.7 10.3003ZM136.3 28.9003C135 28.9003 133.8 28.7003 132.7 28.4003L136.3 16.0003L139.9 28.4003C138.8 28.7003 137.6 28.9003 136.3 28.9003Z"
        fill="white"
      />
      <path
        d="M242.7 10.3003H234L224.1 38.8003H231.7L233.1 34.0003C234.8 34.5003 236.6 34.8003 238.4 34.8003C240.2 34.8003 242 34.5003 243.7 34.0003L245.1 38.8003H252.7L242.7 10.3003ZM238.4 28.9003C237.1 28.9003 235.9 28.7003 234.8 28.4003L238.4 16.0003L242 28.4003C240.9 28.7003 239.6 28.9003 238.4 28.9003Z"
        fill="white"
      />
      <path
        d="M321.4 37.4002C319.5 38.7002 316.5 39.2002 313.3 39.2002C303.3 39.2002 297.6 33.2002 297.6 23.5002C297.6 14.2002 303.3 7.7002 313.2 7.7002C316.2 7.7002 319.2 8.3002 321.3 9.8002V13.8002C319.1 12.4002 316.7 11.7002 313.2 11.7002C306 11.7002 301.8 16.4002 301.8 23.5002C301.8 30.5002 306.2 35.2002 313.5 35.2002C316.7 35.2002 319.2 34.5002 321.5 33.3002V37.4002H321.4Z"
        fill="white"
      />
      <path
        d="M336.8 39.3002C328.1 39.3002 324.3 34.3002 324.3 27.2002C324.3 20.2002 328.2 15.2002 335.3 15.2002C342.5 15.2002 345.3 20.2002 345.3 27.2002V29.0002H328.3C328.9 33.0002 331.4 35.5002 336.9 35.5002C339.6 35.5002 341.9 35.0002 344 34.2002V37.9002C342.1 38.9002 339.2 39.3002 336.8 39.3002ZM328.3 25.5002H341.3C341.1 21.2002 339.1 18.7002 335.1 18.7002C330.9 18.7002 328.7 21.4002 328.3 25.5002Z"
        fill="white"
      />
      <path
        d="M354 38.8002H350.1V15.5002H354V19.6002C355.3 16.9002 357.7 14.9002 362.2 15.2002V19.1002C357.1 18.6002 354 20.1002 354 25.1002V38.8002Z"
        fill="white"
      />
      <path
        d="M374.9 35.0002C375.8 35.0002 376.7 34.8002 377.4 34.7002V38.6002C376.7 38.8002 375.9 39.0002 374.7 39.0002C369.7 39.0002 367.3 36.1002 367.3 31.7002V19.3002H363.5V15.6002H367.3V10.7002H371.2V15.6002H377.4V19.3002H371.2V31.6002C371.2 33.6002 372.4 35.0002 374.9 35.0002Z"
        fill="white"
      />
      <path
        d="M384.6 6.6001C386.2 6.6001 387.4 7.6001 387.4 9.4001C387.4 11.2001 386.2 12.2001 384.6 12.2001C383 12.2001 381.8 11.2001 381.8 9.4001C381.8 7.6001 382.9 6.6001 384.6 6.6001ZM382.5 15.5001H386.5V38.8001H382.5V15.5001Z"
        fill="white"
      />
      <path
        d="M398.1 15.5002H404.1V19.2002H398.1V38.7002H394.2V19.3002H390.4V15.6002H394.2V13.0002C394.2 8.7002 396.6 5.7002 401.6 5.7002C402.8 5.7002 403.6 5.9002 404.3 6.1002V9.8002C403.6 9.7002 402.7 9.6002 401.8 9.6002C399.3 9.6002 398.1 11.0002 398.1 13.1002V15.5002Z"
        fill="white"
      />
      <path
        d="M410.5 6.6001C412.1 6.6001 413.3 7.6001 413.3 9.4001C413.3 11.2001 412.1 12.2001 410.5 12.2001C408.9 12.2001 407.7 11.2001 407.7 9.4001C407.7 7.6001 408.9 6.6001 410.5 6.6001ZM408.4 15.5001H412.4V38.8001H408.4V15.5001Z"
        fill="white"
      />
      <path
        d="M434.9 38.2002C433.5 38.9002 431.4 39.3002 429.2 39.3002C420.9 39.3002 417.1 34.3002 417.1 27.2002C417.1 20.2002 421 15.2002 429.2 15.2002C431.3 15.2002 432.9 15.5002 434.7 16.3002V20.0002C433.2 19.3002 431.6 18.9002 429.4 18.9002C423.4 18.9002 420.9 22.7002 420.9 27.2002C420.9 31.7002 423.4 35.5002 429.5 35.5002C431.9 35.5002 433.4 35.2002 434.8 34.7002V38.2002H434.9Z"
        fill="white"
      />
      <path
        d="M455.2 34.6001C453.7 37.7001 450.9 39.3001 447.3 39.3001C441.1 39.3001 438 34.0001 438 27.2001C438 20.6001 441.3 15.1001 447.8 15.1001C451.2 15.1001 453.8 16.6001 455.2 19.7001V15.6001H459.2V38.9001H455.2V34.6001ZM448.4 35.5001C452 35.5001 455.2 33.2001 455.2 28.1001V26.2001C455.2 21.0001 452.3 18.8001 448.9 18.8001C444.4 18.8001 442.1 21.8001 442.1 27.2001C442.1 32.7001 444.3 35.5001 448.4 35.5001Z"
        fill="white"
      />
      <path
        d="M474.5 35.0002C475.4 35.0002 476.3 34.8002 477 34.7002V38.6002C476.3 38.8002 475.5 39.0002 474.3 39.0002C469.3 39.0002 466.9 36.1002 466.9 31.7002V19.3002H463.1V15.6002H466.9V10.7002H470.8V15.6002H477V19.3002H470.8V31.6002C470.8 33.6002 472 35.0002 474.5 35.0002Z"
        fill="white"
      />
      <path
        d="M484.2 6.6001C485.8 6.6001 487 7.6001 487 9.4001C487 11.2001 485.8 12.2001 484.2 12.2001C482.6 12.2001 481.4 11.2001 481.4 9.4001C481.4 7.6001 482.5 6.6001 484.2 6.6001ZM482.1 15.5001H486.1V38.8001H482.1V15.5001Z"
        fill="white"
      />
      <path
        d="M490.8 27.1001C490.8 20.1001 494.9 15.1001 501.9 15.1001C508.8 15.1001 512.9 20.2001 512.9 27.1001C512.9 34.0001 508.9 39.2001 501.9 39.2001C494.9 39.3001 490.8 34.1001 490.8 27.1001ZM494.7 27.1001C494.7 31.5001 496.9 35.5001 501.9 35.5001C506.8 35.5001 509 31.5001 509 27.1001C509 22.7001 506.9 18.8001 501.9 18.8001C496.9 18.8001 494.7 22.7001 494.7 27.1001Z"
        fill="white"
      />
      <path
        d="M537.3 38.8H533.3V24.8C533.3 20.6 531.6 18.8 527.8 18.8C524.1 18.8 521.5 21.3 521.5 26V38.9H517.5V15.5H521.5V19.3C523 16.6 525.7 15 528.9 15C534.3 15 537.3 18.7 537.3 25.1V38.8Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_815_1211"
        x1="14.9161"
        y1="22.8055"
        x2="5.9611"
        y2="38.3155"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="0.923" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_815_1211">
        <rect width="538" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
